export async function requestTransferSuperoneApiData(): Promise<any> {
  const apiBaseUrl = process.env.PARCEL_API_URL || "";
  // Prevent double slashes in the URL
  const endpointPath = "/api/superone/transfer-superone-api-data";
  // Always expect endpointPath to start with '/'
  const url = `${apiBaseUrl}${endpointPath}`;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
    const data = await res.json();
    return data;
  } catch (err: any) {
    throw new Error(
      err.message || `Failed to fetch transfer-superone-api-data`
    );
  }
}
